export default __webpack_public_path__ + "static/media/Ballroll_00297.c2535d39.png";